var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPutratiobackspread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.5V15L30 38H23.5L7 21.5Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7434 38H63V42.5H39.5L34 48.5L19 33.5H25.5L34 42L37.7434 38Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 38V37.5H63.5001V38H63.0001ZM37.7435 38L37.3785 37.6583C37.473 37.5573 37.6052 37.5 37.7435 37.5V38ZM19.0001 33.5L18.6465 33.8536L17.793 33H19.0001V33.5ZM34.0001 48.5L34.3687 48.8379L34.0158 49.2228L33.6465 48.8536L34.0001 48.5ZM39.5001 42.5L39.1315 42.1621L39.2801 42H39.5001V42.5ZM63.0001 42.5H63.5001V43H63.0001V42.5ZM34.0001 42L34.3652 42.3417L34.012 42.719L33.6465 42.3536L34.0001 42ZM25.5001 33.5V33H25.7072L25.8537 33.1464L25.5001 33.5ZM63.0001 38.5H37.7435V37.5H63.0001V38.5ZM19.3537 33.1464L34.3537 48.1464L33.6465 48.8536L18.6465 33.8536L19.3537 33.1464ZM33.6315 48.1621L39.1315 42.1621L39.8687 42.8379L34.3687 48.8379L33.6315 48.1621ZM39.5001 42H63.0001V43H39.5001V42ZM62.5001 42.5V38H63.5001V42.5H62.5001ZM38.1086 38.3417L34.3652 42.3417L33.635 41.6583L37.3785 37.6583L38.1086 38.3417ZM33.6465 42.3536L25.1465 33.8536L25.8537 33.1464L34.3537 41.6464L33.6465 42.3536ZM25.5001 34H19.0001V33H25.5001V34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPutratiobackspread);
export default __webpack_public_path__ + "static/media/put ratio back spread.2ff887411a963740aed03058c33b0bb4.svg";
export { ForwardRef as ReactComponent };